<script>
import ListJadwalAsesmen from "./list-jadwal-asesmen.vue";

export default {
  components: {
    ListJadwalAsesmen,
  },
};
</script>
<template>
  <b-tabs nav-class="mym-inner-tabs">
    <b-tab title="Jadwal Berdasarkan Kompetensi Jabatan" active>
      <ListJadwalAsesmen tipeAsesmen="kkj" />
    </b-tab>
    <b-tab title="Jadwal Berdasarkan Profesi Jabatan">
      <ListJadwalAsesmen tipeAsesmen="pembinaan_grade" />
    </b-tab>
  </b-tabs>
</template>
